import { render, staticRenderFns } from "./DiverseEditLedgersCard.vue?vue&type=template&id=53e835eb&scoped=true"
import script from "./DiverseEditLedgersCard.vue?vue&type=script&lang=ts"
export * from "./DiverseEditLedgersCard.vue?vue&type=script&lang=ts"
import style0 from "./DiverseEditLedgersCard.vue?vue&type=style&index=0&id=53e835eb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e835eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e835eb')) {
      api.createRecord('53e835eb', component.options)
    } else {
      api.reload('53e835eb', component.options)
    }
    module.hot.accept("./DiverseEditLedgersCard.vue?vue&type=template&id=53e835eb&scoped=true", function () {
      api.rerender('53e835eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/DiverseEditLedgersCard.vue"
export default component.exports